import { render, staticRenderFns } from "./ClassificationManage.vue?vue&type=template&id=a5a7effc&scoped=true"
import script from "./ClassificationManage.vue?vue&type=script&lang=js"
export * from "./ClassificationManage.vue?vue&type=script&lang=js"
import style0 from "./ClassificationManage.vue?vue&type=style&index=0&id=a5a7effc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a7effc",
  null
  
)

export default component.exports